import React from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ClientsSlider from "./components/ClientsSlider";
import About from "./components/About";
import Services from "./components/Services";
import TechStackSlider from "./components/TechStackSlider";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <ClientsSlider />
          <About />
          <Services />
          <TechStackSlider />
          <Team />
          <Contact />
        </main>
        <Footer />
        <CookieConsent />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
